<template>
  <div class="upload-file" :class="{'only-image':isOnlyImageType}">
<!--    <input ref="uploadEl" type="file" class="hidden" :id="`upload-file-${fid}`" multiple :accept="accept" />-->
    <div>
      <ul class="mt-2">
        <li class="upload-file-item mb-2 last:mb-0 relative" v-for="(file, index) in value" :key="file.url">
          <file-item :file="file" @remove="removeFile(index)" />
        </li>
      </ul>
    </div>
    <template v-if="showUploadBtn">
      <!--      <template v-if="!isOnlyImageType">-->
      <!--        <div class="before-file-upload mt-2">-->
      <!--          <label :for="`upload-file-${fid}`">-->
      <!--            <span>上传附件（{{ text }}30M以内）</span>-->
      <!--          </label>-->
      <!--        </div>-->
      <!--      </template>-->
      <!--      <template v-else>-->
      <!--        <div class="before-file-upload mt-2">-->
      <!--          <label :for="`upload-file-${fid}`">-->
      <!--            <van-icon name="photograph" size="24" color="#dcdee0"/>-->
      <!--            <span>上传图片</span>-->
      <!--            <span>（30M以内）</span>-->
      <!--&lt;!&ndash;            <span>上传附件（{{ text }}30M以内）</span>&ndash;&gt;-->
      <!--          </label>-->
      <!--        </div>-->
      <!--      </template>-->
      <van-uploader :accept="accept" :beforeRead="onBeforeRead" :after-read="onAfterRead">
        <div class="before-file-upload mt-2 ">
          <div class="box-wrap">
            <template v-if="isOnlyImageType">
              <van-icon name="photograph" size="24" color="#dcdee0" />
              <span>上传图片</span>
              <span>（30M以内）</span>
            </template>
            <template v-else>
              <span>上传附件（{{ text }}{{ uploadFileMaxSize }}M以内）</span>
            </template>
          </div>
        </div>
      </van-uploader>
    </template>
  </div>
</template>

<script>
import { FileErrorCode, upload, uploadFile, isOnlyImageType, checkFile } from 'dygc'
import { loading } from '@/assets/js/loading'
import FileItem from './FileItem'

let _fid = 0
export default {
  name: 'UploadFiles',
  components: { FileItem },
  props: {
    uploadFileMaxSize:{
      type: Number,
      default: 30,
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    allowTypes: {
      type: Array,
      default: () => []
    },
    checkFileType: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fid: _fid++
    }
  },
  computed: {
    accept() {
      if (this.isOnlyImageType) return 'image/*'
      return null
    },
    isOnlyImageType() {
      if (!this.checkFileType) return false
      return isOnlyImageType(this.allowTypes)
    },
    showUploadBtn() {
      let max = this.max
      return max > this.value.length
    },
    text() {
      let max = this.max
      let min = this.min || -1
      if (max < 0) {
        return ''
      }
      if (min <= 0) {
        return '上限' + max + '个，每个'
      } else {
        return '至少上传' + min + '个附件，' + '上限' + max + '个，每个'
      }
    }
  },
  methods: {
    onBeforeRead(file) {
      const files = Array.isArray(file) ? file : [file]
      const opt = {
        maxSize: this.uploadFileMaxSize,
        unit: 'MB',
        allowTypes: this.checkFileType ? this.allowTypes : [],
      }
      for (let i = 0; i < files.length; i++) {
        const f = files[i]
        const res = checkFile(f, opt)
        if (!res) continue
        if (res.code === FileErrorCode.NO_ALLOW_TYPE) {
          this.$notify({ type: 'warning', message: `文件类型错误，仅允许上传${this.allowTypes.join('、')}格式文件` })
        } else {
          this.$notify({ type: 'warning', message: res.msg })
        }
        return false
      }
      return true
    },
    onAfterRead(file){
      const files = Array.isArray(file) ? file : [file]
      const close = loading({}, 500)
      const promises = []
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let fd = new FormData()
        fd.append('file', file.file)
        promises.push(upload(fd))
      }
      Promise.all(promises)
          .then(res => {
            let value = this.value.slice()
            res.forEach(item => {
              value.push({
                name: item.data.url,
                url: item.data.url
              })
            })
            this.$emit('input', value)
            close()
          })
          .catch(() => {
            close()
          })
    },
    convertFileName(filename = '') {
      filename = decodeURIComponent(filename)
      const splits = filename.split('/')
      filename = splits.pop()
      if (filename.indexOf('_') > -1) {
        let [, ...names] = filename.split('_')
        filename = names.join('_')
      }
      return filename
    },
    removeFile(index) {
      let value = this.value.slice()
      value.splice(index, 1)
      this.$emit('input', value)
    },
    init() {
      uploadFile({
        maxSize: 30,
        unit: 'MB',
        allowTypes: this.checkFileType ? this.allowTypes : [],
        el: this.$refs.uploadEl,
        multiple: true,
        success: files => {
          if (files.length > this.max) {
            this.$notify({ type: 'warning', message: `最多上传${this.max}个文件` })
            return
          }

          const close = loading({}, 500)

          const promises = []

          for (let i = 0; i < files.length; i++) {
            let file = files[i]
            let fd = new FormData()
            fd.append('file', file)
            promises.push(upload(fd))
          }

          Promise.all(promises)
              .then(res => {
                let value = this.value.slice()
                res.forEach(item => {
                  value.push({
                    name: item.data.url,
                    url: item.data.url
                  })
                })
                this.$emit('input', value)
                close()
              })
              .catch(() => {
                close()
              })
        },
        error: err => {
          if (err.code === FileErrorCode.NO_ALLOW_TYPE) {
            this.$notify({ type: 'warning', message: `文件类型错误，仅允许上传${this.allowTypes.join('、')}格式文件` })
          } else {
            this.$notify({ type: 'warning', message: err.msg })
          }
        }
      })
    }
  },
  mounted() {
    // this.init()
  }
}
</script>
